var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfileMenBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "c82ia"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 22V0h20v22zm12.598-9.75a6.807 6.807 0 0 1-5.696 0H6.25A5.251 5.251 0 0 0 1 17.5v1.625C1 20.16 1.84 21 2.875 21h13.75c1.035 0 1.875-.84 1.875-1.875V17.5a5.251 5.251 0 0 0-5.25-5.25zM9.75 11a5 5 0 1 0 0-10 5 5 0 0 0 0 10z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#4258bf",
    strokeMiterlimit: 20,
    strokeWidth: 2,
    d: "M13.25 12.25a5.251 5.251 0 0 1 5.25 5.25v1.625c0 1.035-.84 1.875-1.875 1.875H2.875A1.875 1.875 0 0 1 1 19.125V17.5a5.251 5.251 0 0 1 5.25-5.25h.652a6.807 6.807 0 0 0 5.695 0zM4.75 6a5 5 0 1 1 10 0 5 5 0 0 1-10 0z",
    clipPath: "url(\"#c82ia\")"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileMenBlue);
export default __webpack_public_path__ + "static/media/profile_men_blue.243dec3eddb8824772f1646ae8dc3a0d.svg";
export { ForwardRef as ReactComponent };